module.exports = __webpack_public_path__ + "905ad66c780dd393da29d630d6465a8f.png";